import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

import { Table } from 'src/app/shared/entities/Table';
import { MatTableDataSource } from '@angular/material/table';
import { Tables } from 'src/app/shared/entities/tables';
import { FormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { MenuActions } from 'src/app/shared/enums/menu-actions';
import { PageOptions } from 'src/app/shared/enums/page-modes';
import { PersonnemoraleTypes } from 'src/app/shared/enums/personmoral-types';
import { MatDialog } from '@angular/material/dialog';
import { asyncScheduler, firstValueFrom, Observable, observeOn, of, Subscription } from 'rxjs';
import { DiaologHostComponent } from 'src/app/shared/components/dialogs/dialog-host/dialog-host';
import { ViewService } from 'src/app/admin/core/services/viewservice';
import { ViewDto } from 'src/app/shared/entities/viewdto';
import { TabService } from 'src/app/shared/services/tab.service';
import { MatSort } from '@angular/material/sort';
import { DeleteReq } from 'src/app/shared/entities/deleteReq';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Language } from 'src/app/shared/entities/language';
import { PictosUtils } from 'src/app/shared/utils/pictosUtils';
import { Template } from 'src/app/shared/entities/template';
import { UserService } from 'src/app/admin/core/services/user.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { DynamicViewInfoService } from 'src/app/shared/services/dynamic-view-info.service';

import { IdmlService } from 'src/app/shared/services/idml.service';
import { TableStateService } from 'src/app/shared/services/table-state.service';

import { DynamicDocumentFieldInfoType, DynamicDocumentInfo } from 'src/app/shared/entities/dynamic-document';
import { DynamicViewInfo } from 'src/app/shared/entities/dynamic-view';
import { TranslateService } from '@ngx-translate/core';

interface FlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css'],
})
export class TableComponent implements OnInit, OnChanges, OnDestroy {
    public templates: Template[] = [];

    @Input() public tab: Tables = new Tables();
    @Input() public value = '';
    @Input() public user: any;
    @ViewChild('paginator') paginator: MatPaginator;
    @Output() create = new EventEmitter<Tables>();
    color: string = '';
    visualise = 'Visualisation ';
    dataSourceSubscription: Subscription;
    deleteSubscription: Subscription;
    updateOrAddSubscription: Subscription;

    userIdCheck = localStorage.getItem('userid');
    tables: Table[] = [];
    listedechamps: any[] = ['select'];
    selected = new FormControl();
    subscriptions: Subscription[] = [];
    //service to retrieve data based on datasource
    recherche: string;
    @Input() public datasource = new MatTableDataSource<any>();
    selection = new SelectionModel<any>(true, []);
    clickSelection = new Set<any>();
    tabList: string[] = [];
    pageOptions = PageOptions;
    pageOption = this.pageOptions.WAIT;
    idList: string[] = [];
    type: Map<string, string> = new Map<string, string>();
    entiteName: string = '';
    defaultVisualisation: any = '';
    defaultVisualisationId: string = '';
    defaultView: any = new ViewDto();
    views: ViewDto[] = [];
    deleteReq = new DeleteReq();
    disable: boolean = false;
    filters: { [key: string]: any } = {};
    sorts: Map<string, string> = new Map();
    filterTypes: any = null;

    // Track previous tab ID to detect tab changes
    private previousTabId: string | null = null;
    // Track timeout để có thể cancel khi có lần gọi mới (tránh race condition)
    private populateListeChampsTimeout: any = null;
    // Track xem đã restore state chưa để tránh gọi nhiều lần
    private isRestoringState: boolean = false;
    private restoredViewId: string | null = null;
    private isDataLoadedFromPopulate: boolean = false;
    private isViewManuallySelected: boolean = false; // Track nếu view được chọn manually (không restore)
    private currentTabId: string | null = null; // Lưu tabId hiện tại từ ngOnInit() để sử dụng trong setView()
    // Track paginator sync để tránh race condition khi có nhiều API calls đồng thời
    private isSyncingPaginator: boolean = false;
    private paginatorSyncSubscription: Subscription | null = null;
    // Track khi filter vừa thay đổi để force gọi API (kể cả khi đã có data)
    private isFilterChanged: boolean = false;
    initData: any = null;
    totalElements: number = 0;
    pageIndex: number = 0; // 1-based (for API calls)
    pageSize: number = 25;
    pageSizeOptions = [25, 50, 100, 200, 500, 1000];

    /**
     * Getter để convert pageIndex từ 1-based sang 0-based cho MatPaginator
     * MatPaginator sử dụng 0-based index (0 = page 1, 1 = page 2, ...)
     */
    get paginatorPageIndex(): number {
        return this.pageIndex > 0 ? this.pageIndex - 1 : 0;
    }
    columnDefs: any;
    hidePageSize = false;
    showPageSizeOptions = true;
    showFirstLastButtons = true;
    disabled = false;
    total = 100;
    favoriView: any;
    client: String = environment.client;
    clientTimeZone: number;

    isOpenAddElement: boolean = false;

    isOpenLanguages: boolean = false;

    languages: Language[] = environment.languages.map((lang, index) => {
        return {
            key: lang.locale,
            label: lang.text,
            selected: index === 0,
        };
    });

    @ViewChild(MatSort, { static: true }) sort: MatSort;

    private _transformer = (node: any, level: number) => {
        return {
            expandable: !!node.subChildren && node.subChildren.length > 0,
            name: node.name,
            level: level,
        };
    };

    treeControl = new FlatTreeControl<FlatNode>(
        (node) => node.level,
        (node) => node.expandable,
    );
    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.subChildren,
    );
    treeFlatDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    hasTreeFlat: boolean = false;

    hasChild = (_: number, node: FlatNode) => node.expandable;

    switchOn: string = 'table';

    private _dynamicDocumentInfo: DynamicDocumentInfo | null = null;

    tooltipTranslate = {
        create: '',
        refresh: '',
        visualisation: '',
        language: '',
        import: '',
        export: '',
        delete: '',
    };

    constructor(
        private dash: DashboardComponent,
        private dialog: MatDialog,
        private viewService: ViewService,
        private myTableService: TabService,
        private httpClient: HttpClient,
        public userService: UserService,
        private readonly _dynamicDocumentInfoService: DynamicDocumentInfoService,
        private readonly _dynamicDocumentService: DynamicDocumentService,
        private readonly _dynamicViewInfoService: DynamicViewInfoService,
        private readonly _idmlService: IdmlService,
        private translate: TranslateService,
        private tableStateService: TableStateService,
        private cdr: ChangeDetectorRef,
    ) {
        this.type.set('Associés', PersonnemoraleTypes.ASSOCIE);
        this.type.set('Clients', PersonnemoraleTypes.CLIENT);
        this.type.set('Fournisseurs', PersonnemoraleTypes.FOURNISSEUR);
        this.languages.push({ key: 'all', label: 'Toutes les langues', selected: false });
    }

    async ngOnInit() {
        // 🔧 FIX: Lưu tabId hiện tại để sử dụng trong setView() thay vì gọi getCurrentTabId()
        // Điều này đảm bảo tabId đúng khi component được recreate
        this.currentTabId = this.getCurrentTabId();

        this.clientTimeZone = new Date().getTimezoneOffset() / -60;
        await this.userService.getCurrentUser().then((user) => {
            this.user = user;
        });

        // 🔧 FIX: Restore listedechamps sớm từ saved state để tránh table bị mất columns
        // Điều này quan trọng khi component được recreate sau khi navigate back
        const tabId = this.getCurrentTabId();
        if (tabId && this.tab?.entite) {
            const state = this.tableStateService.getState(tabId, this.tab.entite);
            if (state && state.selectedViewId) {
                // Tạm thời giữ nguyên listedechamps, sẽ được restore đầy đủ trong loadView()
                // Không reset về ['select'] nếu đã có saved view
                this.restoredViewId = state.selectedViewId;
            }
        }

        // Restore state before loading data
        this.restoreStateBeforeLoad();

        this.loadView();
        this.setData();
        this.listenLanguageChange();
    }

    ngOnDestroy(): void {
        // 🔧 FIX: Cleanup paginator sync subscription khi component bị destroy
        if (this.paginatorSyncSubscription) {
            this.paginatorSyncSubscription.unsubscribe();
            this.paginatorSyncSubscription = null;
        }
        this.isSyncingPaginator = false;
    }

    async setView(docInfo: DynamicDocumentInfo) {
        // 🔧 FIX: Sử dụng currentTabId từ ngOnInit() thay vì gọi getCurrentTabId()
        // Điều này đảm bảo tabId đúng khi component được recreate
        const tabId = this.currentTabId || this.getCurrentTabId();

        let allFields = ['select'].concat(docInfo.fields.map((field: any) => field.name));
        let allLabels = ['select'].concat(
            docInfo.fields.map((field: any) =>
                this._dynamicDocumentInfoService.getFieldLabel(field),
            ),
        );

        const viewInfos: DynamicViewInfo[] = await new Promise(
            (resolve: (values: DynamicViewInfo[]) => void) => {
                if (this._dynamicDocumentInfo) {
                    this._dynamicViewInfoService
                        .findByDocumentName(this._dynamicDocumentInfo.documentName)
                        .subscribe((viewInfos: DynamicViewInfo[]) => resolve(viewInfos));
                } else {
                    resolve([]);
                }
            },
        );

        // Clear existing views before loading new ones to avoid duplicates
        this.views = [];

        // Flag to track if view was restored from tableStateHistory
        let isViewRestored = false;

        if (viewInfos.length === 0) {
            // Default view (all fields)
            this.defaultView = new ViewDto();
            this.defaultView.champs = allFields;
            this.defaultView.labels = allLabels;
            this.defaultView.id = '1';
            this.defaultView.isselected = this.views?.length == 0;
            this.defaultView.nom = 'Default';
            this.defaultView.entite = this.tab.entite;

            if (this.views?.length == 0) {
                this.listedechamps = allFields;
            }

            this.views.push(this.defaultView);
        } else {
            this.favoriView =
                this.user?.viewfavoris?.find(
                    (item: any) => item.entite === this._dynamicDocumentInfo?.documentName,
                ) ?? null;

            for (let viewInfo of viewInfos) {
                const view: ViewDto = new ViewDto();
                view.id = viewInfo.id;
                view.nom = viewInfo.viewName;
                view.entite = this.tab.entite;
                view.isfavori = false;
                view.ownerid = viewInfo.ownerId;
                view.isselected = false;
                view.filter = viewInfo.filters;
                //view.filter = [];
                view.isPrivate = viewInfo?.isPrivate ?? false;

                const champs: any = [];
                viewInfo.documentFields?.forEach((field: string) => {
                    champs.push(field);
                });

                view.champs = Object.assign({}, champs);

                const labels: any = [];
                viewInfo.documentFieldsLabel?.forEach((field: string) => {
                    labels.push(field);
                });
                view.labels = Object.assign({}, labels);

                const userId = localStorage.getItem('userid');

                if (userId === view.ownerid || !view.ownerid || !view.isPrivate) {
                    this.views.push(view);
                }
            }

            // FIX: Restore saved view from TableStateService FIRST (before setting favorite/default)
            // This ensures the selected view is restored correctly when returning to the tab
            // 🔧 FIX: CHỈ restore view khi tab đã có state được lưu trước đó (ví dụ: back từ detail của cùng tab)
            // Với tab mới (tabId = "0"), không restore view từ state, chỉ dùng default view
            // 🔧 FIX: Sử dụng tabId đã được tính toán ở đầu function, KHÔNG gọi lại getCurrentTabId()
            // tabId đã được tính toán ở dòng 370: const tabId = this.currentTabId || this.getCurrentTabId();
            let restoredView: ViewDto | null = null;
            let tabState: any = null;

            // CHỈ restore view khi tabId bắt đầu bằng "viewid-" (tab đã được mở trước đó, back từ detail)
            // KHÔNG restore view khi tabId = "0" (tab mới)
            if (tabId && tabId.startsWith('viewid-')) {
                // 1. Try to get state for current tab
                const stateKey = `table_state_${tabId}_${this.tab.entite}`;
                tabState = this.tableStateService.getState(tabId, this.tab.entite);

                // 2. Fallback: If no state for current tab, try to get state for same entity (from other tabs)
                // NGUYÊN NHÂN: Khi user click vào data sheet, hệ thống tạo tab mới với tabId mới (ví dụ: viewid-104)
                // Nhưng state được lưu với tabId cũ (ví dụ: viewid-101) khi user chọn view
                // Vì vậy, khi back về visualisation table, tabId khác với tabId khi user chọn view, nên không tìm thấy state
                // Giải pháp: Fallback để tìm state của tab khác cùng entity
                if (!tabState || !tabState.selectedViewId) {
                    const fallbackState = this.tableStateService.getStateForEntity(
                        this.tab.entite,
                        tabId,
                    );

                    // 🔧 FIX: Nếu tìm thấy state từ fallback, copy sang tabId hiện tại để lần sau tìm thấy đúng
                    if (fallbackState && tabId && tabId.startsWith('viewid-')) {
                        // Copy state sang tabId hiện tại
                        this.tableStateService.saveState(tabId, this.tab.entite, fallbackState);
                    }

                    tabState = fallbackState;
                }

                if (tabState && tabState.selectedViewId) {
                    const savedView = this.views.find((v) => v.id === tabState.selectedViewId);
                    if (savedView) {
                        restoredView = savedView;
                        isViewRestored = true;
                    }
                }
            }

            if (restoredView) {
                // Use restored view (highest priority)
                // Unselect all views first
                this.views.forEach((v) => (v.isselected = false));
                // Select the restored view
                restoredView.isselected = true;
                this.defaultView = restoredView;
                this.defaultVisualisation = restoredView.nom || '';
                // 🔧 FIX: Lưu viewId đã restore để tránh restore lại trong restoreTableState()
                this.restoredViewId = restoredView.id;
                this.populateListeChamps(restoredView);

                // Apply filters from tabState (most recent) or from savedView
                if (
                    tabState &&
                    tabState.filters &&
                    Array.isArray(tabState.filters) &&
                    tabState.filters.length > 0
                ) {
                    this.filters = tabState.filters;
                    this.tab.filresappliques = tabState.filters;
                } else if (Array.isArray(restoredView.filter)) {
                    this.filters = restoredView.filter;
                    this.tab.filresappliques = restoredView.filter;
                } else {
                    this.filters = [];
                    this.tab.filresappliques = [];
                }

                // Restore sorts from tabState if available
                if (tabState && tabState.sort && tabState.sort.active) {
                    this.sorts = new Map();
                    if (tabState.sort.direction !== null && tabState.sort.direction !== undefined) {
                        this.sorts.set(tabState.sort.active, tabState.sort.direction);
                    } else {
                        this.sorts.set(tabState.sort.active, '');
                    }
                }

                // 🔧 FIX: Restore paginator state BEFORE calling populateTableByfiltersAndSorts()
                // This ensures API calls use the correct pageIndex when loading data
                // Pass tabState to ensure we use the same state that was found in setView()
                this.restoreStateBeforeLoad(tabState);

                // Load data with restored view, filters, and sorts
                // 🔧 FIX: Gọi trực tiếp không dùng setTimeout
                // populateListeChamps() đã được gọi ở trên (line 471), columnDefs đã được set
                // 🔧 FIX: Set flag để loadView() biết rằng data đã được load từ populateTableByfiltersAndSorts()
                this.isDataLoadedFromPopulate = true;
                this.populateTableByfiltersAndSorts(this.filters, this.sorts);

                return; // Exit early if saved view was restored
            } else {
                // FALLBACK: If no restored view, use favorite or default view
                // This only happens if:
                // 1. No tabStateHistory exists
                // 2. selectedViewId not found in views
                // 3. First time opening this tab
                // IMPORTANT: Follow same logic as selectView() to ensure consistency
                this.favoriView =
                    this.user?.viewfavoris?.find(
                        (item: any) => item.entite === this._dynamicDocumentInfo?.documentName,
                    ) ?? null;

                // Unselect all views first (same as selectView())
                this.views.forEach((v) => (v.isselected = false));

                // Determine which view to use (favorite > last view)
                this.defaultView = this.views[this.views.length - 1];
                const findFavorite = this.views.findIndex(
                    (item) => item?.nom === this.favoriView?.nom,
                );
                if (findFavorite > -1) {
                    this.defaultView = this.views[findFavorite];
                }

                // Select the default view (same as selectView())
                this.defaultView.isselected = true;
                this.defaultVisualisation = this.defaultView.nom || '';

                // Ensure populateListeChamps is called for fallback view
                this.populateListeChamps(this.defaultView);
            }
        }

        // Apply filters from selected view (if not already restored from tabState)
        // This handles the case when fallback view is used and has filters
        let selectedView = this.views.find((el) => el.isselected);

        if (selectedView && !isViewRestored) {
            // Only apply filters if view was NOT restored (restored view already has filters applied above)
            this.populateListeChamps(selectedView);

            this.filters = [];
            // Ensure filters is array format
            if (!Array.isArray(this.filters)) {
                this.filters = [];
            }
            selectedView?.filter?.forEach((filter, index) => {
                if (this.filters && index !== undefined && Array.isArray(this.filters)) {
                    // Check if filter already exists and update it, otherwise add it
                    const existingIndex = (this.filters as any[]).findIndex(
                        (f: any) => f?.fieldName === filter.fieldName,
                    );
                    if (existingIndex >= 0) {
                        this.filters[existingIndex] = filter;
                    } else {
                        (this.filters as any[]).push(filter);
                    }
                }
            });
        }
        this.defaultVisualisation = this.defaultView !== undefined ? this.defaultView.nom : '';
    }

    async loadView() {
        // we might create a service to verify if the entity is dnamic
        if (this.tab.entite.includes('dynamic') && this.tab.entite !== 'dynamic_document_info') {
            this._dynamicDocumentInfo = await this.retrieveDynamicDocumentInfo(this.tab.entite);
        }

        if (this._dynamicDocumentInfo) {
            // For dynamic documents

            await this.setView(this._dynamicDocumentInfo);

            this.tab.isDynamic = true;
            this.entiteName = this._dynamicDocumentInfo.documentName;
            this.tab.entite = this.entiteName;
            this.tab.droitTitle = this._dynamicDocumentInfoService.getLabel(
                this._dynamicDocumentInfo,
            );

            // 🔧 FIX: Không gọi restoreStateBeforeLoad() ở đây vì setView() đã restore state rồi
            // Gọi restoreStateBeforeLoad() sẽ overwrite filters đã được restore trong setView()
            // Chỉ restore paginator state nếu chưa được restore trong setView()
            const tabId = this.currentTabId || this.getCurrentTabId();
            if (tabId && tabId.startsWith('viewid-')) {
                const state =
                    this.tableStateService.getState(tabId, this.tab.entite) ||
                    this.tableStateService.getStateForEntity(this.tab.entite, tabId);
                if (state && (state.pageIndex !== undefined || state.pageSize !== undefined)) {
                    // Chỉ restore paginator nếu chưa được restore trong setView()
                    if (this.pageIndex === 1 && state.pageIndex !== undefined) {
                        this.pageIndex = state.pageIndex + 1;
                    }
                    if (this.pageSize === 25 && state.pageSize !== undefined) {
                        this.pageSize = state.pageSize;
                    }
                }
            }

            // 🔧 FIX: Chỉ gọi API nếu data chưa được load từ populateTableByfiltersAndSorts()
            // Nếu setView() đã gọi populateTableByfiltersAndSorts(), không cần gọi API lại
            // Check cả flag và data thực tế để đảm bảo data đã được load
            const currentDataCount = this.datasource?.data?.length || 0;
            const currentTotalElements = this.totalElements || 0;
            const currentFiltersCount = Array.isArray(this.filters) ? this.filters.length : 0;

            // Skip API call nếu:
            // 1. Flag isDataLoadedFromPopulate = true VÀ
            // 2. Data đã được load (dataCount > 0 hoặc totalElements > 0) HOẶC
            // 3. Đang trong quá trình load (flag = true nhưng data chưa có) - đợi populateTableByfiltersAndSorts() hoàn thành
            const hasDataLoaded = currentDataCount > 0 || currentTotalElements > 0;
            // Nếu flag = true nhưng data chưa load, đợi populateTableByfiltersAndSorts() hoàn thành (không gọi API)
            // Nếu flag = true và data đã load, skip API call
            const shouldSkipApiCall = this.isDataLoadedFromPopulate;

            // Chỉ reset flag nếu data đã được load thực sự
            if (shouldSkipApiCall && hasDataLoaded) {
                this.isDataLoadedFromPopulate = false; // Reset flag sau khi data đã được load
            }

            if (!shouldSkipApiCall) {
                // 🔧 FIX: Sử dụng pageIndex thay vì hardcode page: 1
                // pageIndex là 1-based, API cần 1-based, nên dùng trực tiếp
                const page = this.pageIndex > 0 ? this.pageIndex : 1;

                await this._dynamicDocumentService
                    .find({
                        collectionName: this._dynamicDocumentInfo.documentName,
                        filters: this.parseFilters(this.convertFiltersToObject(this.filters)),
                        sorts: Object.fromEntries(this.sorts),
                        page: page,
                        pageSize: this.pageSize,
                        timezone: this.clientTimeZone,
                    })
                    .subscribe(async (data: any) => {
                        if (this._dynamicDocumentInfo === null) {
                            return;
                        }

                        this.datasource.data = data.content;
                        this.totalElements = data.totalElements;

                        this.myTableService.setDataSource(this.tab.entite, this.datasource);

                        // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                        // Data đã có trong datasource.data, không cần setTimeout
                        this.restoreTableState();
                    });
            }
        } else {
            this.loadDefaultView();
        }

        this.viewService.visualisationEvent.subscribe((x) => {
            if (x !== undefined && x !== null) {
                //this.populateListeChamps(x);
                let viewIndex = this.views.findIndex((view) => view.id === x.id);
                x.isselected = true;
                if (viewIndex === -1) this.views.push(x);
                else this.views[viewIndex] = x;
                this.selectView(x);
            }
        });
        this.viewService.deleteEvent.subscribe((IdsViewtoRemove) => {
            if (IdsViewtoRemove.find((x) => x === this.defaultView.id)) {
                this.defaultView = undefined;
            }

            this.views = this.views.filter((x) => !IdsViewtoRemove.includes(x.id));

            this.loadDefaultView(); // I changed this today
        });
    }

    async setData() {
        this.myTableService.setDataSource(this.tab.entite, this.datasource);
        // if (
        //   this.tab.entite === 'personnemorale' ||
        //   this.tab.entite === 'personnephysique'
        // ) {
        // }
        // if (this.tab.entite === 'categorie') {
        // }
        //this.views = this.viewService.getViews(this.tab.title, this.tab.entite);

        //let def = this.views.find((x) => x.favori === true);

        if (this.tab.entite == 'TachePlanifiee') {
            this.tab.isMenuVisible = false;

            // this.defaultView.listedechamps = this.listedechamps;
            // this.rxStompService.activate();
            // this.taskService.subscribe((message: any) => {
            //   const bodyObject = JSON.parse(message?.body);

            //   bodyObject.nextExecutionTime = this.utilService.formatDate(
            //     bodyObject.nextExecutionTime
            //   );
            //   this.myTableService.updateOrAddItem(bodyObject, this.tab.entite);
            // });

            return;
        }

        this.deleteSubscription = this.myTableService.deleteEvent.subscribe((totalElements) => {
            this.datasource = this.myTableService.getDataSource(this.tab.entite);

            this.initData = this.datasource.data;

            this.totalElements = totalElements;
        });
        this.updateOrAddSubscription = this.myTableService.updateDataEvent.subscribe(
            (totalElements) => {
                this.datasource = this.myTableService.getDataSource(this.tab.entite);

                this.initData = this.datasource.data;
                this.totalElements = this.datasource.data.length;
            },
        );

        const url: string = `template/${
            this.tab.entite.toLowerCase() + (this.tab.isDynamic ? '' : 'dto')
        }`;

        const rs: any = await this.httpClient.get(url).toPromise();
        if (rs !== null) {
            this.templates = rs;
        }
        this.initFiltres();
        this.loadDynamicDocuments();
    }

    loadUserViews(): Observable<ViewDto[]> {
        let viewRequest = new ViewDto();
        viewRequest.entite = this.tab.entite;
        viewRequest.ownerid = localStorage.getItem('userid');
        return this.viewService.getUserViews(viewRequest);
    }
    loadDefaultView() {
        // Always reload views to ensure we have the latest and complete views list
        // This is critical when returning to a tab - we need fresh views to match saved selectedViewId
        // Even if views exist, they may be incomplete (e.g., only Default view loaded initially)
        this.loadUserViews().subscribe((x: ViewDto[]) => {
            this.views = x.map((view) => ({
                ...view,
                filter: view?.filter?.map((filter) => ({ ...filter, fieldName: filter.champ })),
            }));

            // Now handleViews() will have complete views list to restore saved view
            // This ensures savedViewId can be found in this.views
            this.handleViews();
        });
    }

    private handleViews() {
        if (this.views !== undefined && this.views !== null) {
            // Try to restore selectedViewId from tableStateHistory first
            const tabId = this.getCurrentTabId();
            let savedViewId: any | null = null;

            if (tabId) {
                const tabState = this.tableStateService.getState(tabId, this.tab.entite);
                if (tabState && tabState.selectedViewId) {
                    savedViewId = tabState.selectedViewId;
                    const savedView = this.views.find((v) => v.id === savedViewId);
                    if (savedView) {
                        // Unselect all views first
                        this.views.forEach((v) => (v.isselected = false));
                        // Select the saved view
                        savedView.isselected = true;
                        this.defaultView = savedView;
                        this.defaultVisualisation = savedView.nom || '';
                        // 🔧 FIX: Lưu viewId đã restore để tránh restore lại trong restoreTableState()
                        this.restoredViewId = savedView.id;

                        // 🔧 FIX: Restore listedechamps NGAY LẬP TỨC để tránh table bị mất columns
                        // Điều này quan trọng khi component được recreate sau khi navigate back
                        const newListedechamps: string[] = ['select'];
                        for (const [key, value] of Object.entries(savedView.champs)) {
                            if (!newListedechamps.some((x) => x === value)) {
                                newListedechamps.push(value);
                            }
                        }
                        if (
                            newListedechamps.length !== null &&
                            newListedechamps.find((x) => x === 'id') === undefined
                        ) {
                            newListedechamps.push('id');
                        }
                        if (this.tab.entite == 'TachePlanifiee') {
                            const filteredList = newListedechamps.filter((x) => {
                                return x != 'select';
                            });
                            this.listedechamps = filteredList;
                        } else {
                            this.listedechamps = [...newListedechamps];
                        }
                        this.populateListeChamps(savedView);

                        // Apply filters from saved view or from tabState
                        // Keep filters as array format to match onFilterChange expectations
                        // Filters should already be restored by restoreStateBeforeLoad(), but ensure they're set
                        if (
                            tabState.filters &&
                            Array.isArray(tabState.filters) &&
                            tabState.filters.length > 0
                        ) {
                            // Use saved filters from tabState (most recent) - keep as array
                            this.filters = tabState.filters;
                            this.tab.filresappliques = tabState.filters;
                        } else if (Array.isArray(savedView.filter)) {
                            // Fallback to view filters - keep as array
                            this.filters = savedView.filter;
                            this.tab.filresappliques = savedView.filter;
                        } else if (
                            !this.filters ||
                            (Array.isArray(this.filters) && this.filters.length === 0)
                        ) {
                            this.filters = [];
                            this.tab.filresappliques = [];
                        }

                        // Restore sorts from tabState if available (highest priority)
                        // This ensures data is loaded with correct sort
                        if (tabState.sort && tabState.sort.active) {
                            this.sorts = new Map();
                            if (
                                tabState.sort.direction !== null &&
                                tabState.sort.direction !== undefined
                            ) {
                                this.sorts.set(tabState.sort.active, tabState.sort.direction);
                            } else {
                                this.sorts.set(tabState.sort.active, '');
                            }
                        }

                        // Load data with restored view, filters, and sorts
                        // 🔧 FIX: Gọi trực tiếp không dùng setTimeout
                        // populateListeChamps() đã được gọi ở trên (line 902), columnDefs đã được set
                        // Filters and sorts are already set above, pass them to populateTableByfiltersAndSorts
                        // populateTableByfiltersAndSorts will handle the conversion from array to object if needed
                        this.populateTableByfiltersAndSorts(this.filters, this.sorts);

                        return; // Exit early if saved view was restored
                    }
                }
            }

            // If no saved view, use favorite or default
            this.favoriView = this.views.find((x) => x.isfavori === true);

            if (
                this.favoriView !== undefined &&
                this.favoriView !== null &&
                this.favoriView.champs !== undefined &&
                this.favoriView !== null &&
                this.favoriView.champs !== null
            ) {
                this.defaultView = this.favoriView;
                this.defaultView.isselected = true;
            } else if (
                this.views.length > 0 &&
                this.defaultView !== undefined &&
                this.defaultView !== null
            ) {
                // 🔧 FIX: KHÔNG reset listedechamps nếu đã có saved view cần restore
                // Chỉ reset nếu không có saved view (sẽ được restore sau)
                const tabId = this.getCurrentTabId();
                const tabState = tabId
                    ? this.tableStateService.getState(tabId, this.tab.entite)
                    : null;
                const hasSavedView =
                    tabState &&
                    tabState.selectedViewId &&
                    this.views.find((v) => v.id === tabState.selectedViewId);

                // CHỈ reset nếu không có saved view cần restore
                // Nếu có saved view, giữ nguyên listedechamps để tránh table bị mất
                if (!hasSavedView) {
                    this.listedechamps = ['select'];
                }
                this.defaultView = this.views[0];
                this.defaultView.isselected = true;
            } else if (
                this.defaultView === undefined ||
                (this.defaultView !== undefined && this.views.length === 0)
            ) {
                this.defaultView = new ViewDto();
                this.defaultView.champs = new Map([
                    ['select', ''],
                    ['id', 'id'],
                    ['nom', 'nom'],
                    ['code', 'code'],
                ]);

                this.defaultView.id = '1';
                this.defaultView.isselected = true;
                this.defaultView.nom = 'Default';
                this.defaultView.entite = this.tab.entite;
            }

            if (this.tab.entite === 'dynamic_document_info') {
                this.defaultView.champs = ['select', 'id', 'documentName'];
                this.defaultView.labels = ['select', 'id', 'Nom du document'];
            }

            if (this.defaultView !== undefined && this.defaultView !== null) {
                this.defaultView.isselected = true;
                // Ensure defaultVisualisation is set to the default view name
                this.defaultVisualisation = this.defaultView.nom || '';

                this.populateListeChamps(this.defaultView);

                // 🔧 FIX: Gọi selectView với isManual=false vì đây là automatic selection
                this.selectView(this.defaultView, false);
            }
        }
    }

    populateListeChamps(view: ViewDto) {
        if (!view) {
            view = new ViewDto();
            view.champs = new Map([
                ['select', ''],
                ['id', 'id'],
                ['nom', 'nom'],
            ]);

            view.id = '1';
            view.nom = 'Default';
            view.entite = this.tab.entite;
        }

        // 🔧 FIX: Kiểm tra xem đã set view này chưa để tránh gọi nhiều lần
        // Điều này quan trọng khi populateListeChamps() được gọi từ nhiều nơi
        // NHƯNG: KHÔNG return nếu listedechamps rỗng hoặc chưa có, vì có thể cần set lại
        const viewId = view?.id;
        if (
            viewId &&
            this.restoredViewId === viewId &&
            this.listedechamps &&
            this.listedechamps.length > 0 &&
            this.defaultView &&
            this.defaultView.id === viewId &&
            this.listedechamps.length > 1 // Phải có ít nhất 2 columns (select + 1 column khác)
        ) {
            // Đã set view này rồi và listedechamps đã có đầy đủ, không cần set lại
            return;
        }

        // 🔧 FIX: Tạo array mới để đảm bảo Angular Material Table detect change
        // Không clear listedechamps thành [] trước vì có thể gây mất table nếu timeout bị cancel
        const newListedechamps: string[] = ['select'];
        for (const [key, value] of Object.entries(view.champs)) {
            if (!newListedechamps.some((x) => x === value)) {
                newListedechamps.push(value);
            }
        }

        if (
            newListedechamps.length !== null &&
            newListedechamps.find((x) => x === 'id') === undefined
        ) {
            newListedechamps.push('id');
        }

        // 🔧 FIX: Set trực tiếp không dùng setTimeout để tránh mất table
        // Việc tạo array mới [...newListedechamps] đã đủ để Angular detect change
        if (this.tab.entite == 'TachePlanifiee') {
            const filteredList = newListedechamps.filter((x) => {
                return x != 'select';
            });
            this.listedechamps = filteredList;
        } else {
            this.listedechamps = [...newListedechamps];
        }

        this.defaultView = view;
        this.defaultView.isselected = true;
        this.columnDefs = this._dynamicDocumentInfo?.fields;

        // Lưu viewId đã set để tránh set lại
        if (viewId) {
            this.restoredViewId = viewId;
        }

        // 🔧 FIX: Force change detection để đảm bảo Angular Material Table update columns
        this.cdr.detectChanges();
    }

    /**
     * TrackBy function để force Angular Material Table recreate columns khi listedechamps thay đổi
     */
    trackByColumn(index: number, column: string): string {
        return column;
    }

    async ngOnChanges(change: SimpleChanges) {
        if (change['tab']) {
            const previousTab = change['tab'].previousValue;
            const currentTab = change['tab'].currentValue;

            // 1. SAVE STATE khi rời tab trước đó
            if (previousTab && previousTab.entite) {
                const previousTabId = this.getCurrentTabId();
                if (previousTabId) {
                    // Save current state before switching tabs
                    this.saveTableState();
                }
            }

            // 2. Update current tab
            this.tab = currentTab;
            this.entiteName = this.tab.entite;
            this.previousTabId = this.getCurrentTabId();

            // 🔧 FIX: Reset restore state flags khi tab thay đổi
            this.isRestoringState = false;
            this.restoredViewId = null;
            this.isViewManuallySelected = false; // Reset flag khi component recreate
            // 🔧 FIX: Update currentTabId khi tab thay đổi
            this.currentTabId = this.getCurrentTabId();

            // 3. RESTORE STATE khi quay lại tab
            // Restore state BEFORE loading views/data
            this.restoreStateBeforeLoad();

            this.filters = this.tab.filresappliques;

            // 4. Load views và restore selected view
            // loadView() will call setView() for dynamic documents or loadDefaultView() for non-dynamic
            // Both will restore saved view from TableStateService after views are loaded
            this.loadView();
        }
    }

    hasMultiTemplates() {
        return this.templates !== undefined && this.templates !== null && this.templates.length > 0;
    }

    loadSortedData(sortColumn: string, sortDirection: string) {}

    isFavoriView(view: ViewDto): boolean {
        return view?.nom === this.favoriView?.nom;
    }
    setFavoriView(view: ViewDto) {
        view.favori = true;
        view.ownerid = localStorage.getItem('userid');
        this.favoriView = view;
        let tmpFilter = view.filter
            ? view.filter.map((filter) => {
                  if (filter.fieldName)
                      return {
                          champ: filter.fieldName,
                          conditions: filter.conditions.map((cond: any) => {
                              return { conditionType: cond.type, value: cond.value };
                          }),
                      };
                  else return filter;
              })
            : [];
        this.viewService.setFavoriView({ ...view, filter: tmpFilter });
        let tempUserFavoriteArr = this.user?.viewfavoris;
        if (Array.isArray(tempUserFavoriteArr)) {
            tempUserFavoriteArr = tempUserFavoriteArr.map((item) => {
                if (item.entite !== this.favoriView?.entite) return item;

                return this.favoriView;
            });

            this.userService.setFavourViews(tempUserFavoriteArr);
        }
    }

    rafraichir() {
        this.selection.clear();
        if (!this._dynamicDocumentInfo) {
            // 🔧 FIX: Gọi selectView với isManual=false vì đây là refresh (automatic)
            this.selectView(this.defaultView, false);
        } else {
            this.loadDynamicDocuments();
        }
    }

    filtreMotCles(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.datasource.filter = filterValue.trim().toLowerCase();
    }

    supprime(view: ViewDto, entitname: string) {
        this.tab.entite = entitname;
        this.tab.totalElements = this.totalElements;

        this.tab.view = view;
        this.tab.dialogName = 'supprime';
        this.tab.msg = `Voulez-vous vraiment supprimer cette visualisation?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });
    }
    importerfichier() {
        this.tab.dialogName = 'import-fichier';
        this.tab.locales = this.getLocales();

        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: "Importer à partir d'un fichier CSV, XLS, XLXS",
                msg: ``,
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((refresh) => {
            if (refresh) {
                this.selection.clear();
                this.rafraichir();
            }
        });
    }
    exporterfichier() {
        this.tab.dialogName = 'export-fichier';
        this.tab.view = this.defaultView;

        let resultFilter: any = this.filters;
        const valueByKey = Object.entries(resultFilter).filter(([key]) => isNaN(Number(key)));
        //const result = valueByKey.map((el) => el[1]);
        const result = Array.isArray(this.filters)
            ? this.filters.filter((f: any) => f !== null && f !== undefined)
            : Object.values(this.filters || {}).filter((f: any) => f !== null && f !== undefined);
        this.tab.filresappliques = result;

        this.tab.ids = this.selection.selected.map((s) => s.id);
        this.tab.locales = this.getLocales();
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: "Exporter à partir d'un fichier CSV, XLS, XLXS",
                msg: ``,
                tab: this.tab,
            },
        });
    }

    suppressiondemasse() {
        this.tab.totalElements = this.totalElements;
        this.deleteReq.idList = this.selection.selected.map((cont) => {
            return cont.id;
        });
        //this.tab.dialogName = 'scheduler';
        this.tab.dialogName = 'supprime';
        this.tab.deleteReq = this.deleteReq;

        this.tab.msg = `Voulez-vous vraiment supprimer les enregistrements`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                msg: `Voulez-vous vraiment supprimer les enregistrements`,
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.selection.clear();
                this.datasource.data = this.datasource.data.filter((x) => {
                    return !this.selection.selected.includes(x);
                });

                this.initData = this.datasource.data;
                this.loadDynamicDocuments();
            } else {
                this.rafraichir();
            }
        });
    }

    supprimView(view: ViewDto) {
        if (view.isfavori) {
            this.tab.deleteReq = {
                idList: [view.id],
                isfavori: true,
                ownerid: localStorage.getItem('userid'),
                view: view,
            };
        } else {
            this.tab.deleteReq = {
                idList: [view.id],
                isfavori: false,
                ownerid: localStorage.getItem('userid'),
                view: view,
            };
        }

        let enttemp = this.tab.entite;
        this.tab.entite = this.tab.isDynamic ? 'dynamic_view_info' : 'view';
        this.tab.dialogName = 'supprime';
        this.tab.msg = `Voulez-vous vraiment supprimer cette visualisation?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.tab.entite = enttemp;
            this.loadDefaultView();

            // I do not think this is necessary, the deletion subscription alreaddy calls this method
        });
    }

    updatetableListItem(searchprop: any, newValue: any) {
        const users = this.datasource.data; // Get current data
        const index = users.findIndex((item) => item.id === searchprop);

        if (index >= 0) {
            users[index] = newValue; // Replace user with new data
            this.datasource.data = [...users]; // Set new data to the dataSource
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.datasource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this.datasource.data);
    }

    checkboxLabel(element?: any): string {
        if (!element) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(element) ? 'deselect' : 'select'} element ${
            element.id + 1
        }`;
    }

    removeTab(index: number) {
        this.tables.splice(index, 1);
    }

    removeTabList(index: number) {
        this.tabList.splice(index, 1);
    }

    creerVisualisation() {
        this.tab.dialogName = 'visualisation';
        this.tab.view = new ViewDto();
        this.tab.entite = this.entiteName;

        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: "Création d'une visualisation",
                msg: ``,
                tab: { ...this.tab, allFields: this._dynamicDocumentInfo?.fields },
            },
        });

        dialogRef.afterClosed().subscribe((newView) => {
            if (newView?.id) this.views.push(newView);
            this.selectView(newView);
            // if (this.tab.isDynamic) {
            //     let dynamicViewInfo = new DynamicViewInfo();
            //     dynamicViewInfo.viewName = newView.nom;
            //     dynamicViewInfo.documentName = newView.entite;
            //     dynamicViewInfo.documentFields = Object.values(newView.champs);
            //     dynamicViewInfo.documentFieldsLabel = Object.values(newView.labels);
            //     dynamicViewInfo.filters = []; // A MODIFIER
            //     dynamicViewInfo.sorts = new Map(); // A MODIFIER

            //     this._dynamicViewInfoService.saveView(dynamicViewInfo).then((res) => { });
            // } else {
            //     this.viewService.saveViews(newView);
            // }
        });
    }

    async selectView(view: ViewDto, isManual: boolean = true) {
        // 🔧 FIX: Đánh dấu view được chọn manually để prevent restoreTableState() overwrite
        // CHỈ set flag khi thực sự là manual selection (user click)
        // Không set khi gọi từ handleViews(), rafraichir(), etc. (automatic)
        this.isViewManuallySelected = isManual;

        // 🔧 FIX: Reset restore state flags khi select view manually
        this.isRestoringState = false;
        this.restoredViewId = null;

        // 🔧 FIX: Reset paginator state khi user chọn visualization manually
        // Khi chuyển visualization, reset về trang 1 và pageSize mặc định
        if (isManual) {
            this.pageIndex = 0;
            this.pageSize = 25;
            if (this.paginator) {
                this.paginator.pageIndex = 0;
                this.paginator.pageSize = 25;
            }
        }

        // 🔧 FIX: Tìm view trong this.views trước, đảm bảo dùng cùng reference
        let el = this.views.find((el) => el?.nom === view?.nom);
        if (el) {
            this.views.map((elx) => (elx.isselected = false));
            el.isselected = true;
            // 🔧 FIX: Dùng 'el' từ this.views thay vì 'view' parameter để đảm bảo cùng reference
            this.defaultView = el;
        } else {
            // Nếu không tìm thấy trong this.views, vẫn dùng view parameter
            this.defaultView = view;
        }

        this.defaultVisualisation = view !== undefined ? view.nom : '';

        // Merge view filters with existing filters (preserve user-added filters)
        // View filters are considered default/base filters, user filters should be preserved
        if (Array.isArray(view.filter) && view.filter.length > 0) {
            // Convert current filters to array format if needed
            let currentFiltersArray: any[] = [];
            if (Array.isArray(this.filters)) {
                currentFiltersArray = [...this.filters];
            } else if (this.filters && typeof this.filters === 'object') {
                Object.keys(this.filters).forEach((key) => {
                    if (this.filters[key]) {
                        if (this.filters[key].fieldName) {
                            currentFiltersArray.push(this.filters[key]);
                        } else {
                            currentFiltersArray.push({
                                fieldName: key,
                                ...this.filters[key],
                            });
                        }
                    }
                });
            }

            // Merge view filters with existing filters
            // View filters are base/default filters, existing user filters take precedence
            view.filter.forEach((viewFilter) => {
                if (viewFilter && viewFilter.fieldName) {
                    // Check if filter already exists (user-added filter takes precedence)
                    const existingIndex = currentFiltersArray.findIndex(
                        (f: any) => f?.fieldName === viewFilter.fieldName,
                    );
                    if (existingIndex >= 0) {
                        // Keep existing filter (user-added), don't override with view filter
                        // Only update if it's a view filter (not user-added)
                    } else {
                        // Add view filter (default filter)
                        currentFiltersArray.push(viewFilter);
                    }
                }
            });

            this.filters = currentFiltersArray;
        } else if (!view.filter || (Array.isArray(view.filter) && view.filter.length === 0)) {
            // If view has no filters, keep existing filters (don't clear them)
            // Only clear if filters is null/undefined/empty
            if (!this.filters || (Array.isArray(this.filters) && this.filters.length === 0)) {
                this.filters = [];
            }
        }

        this.tab.filresappliques = view.filter;

        // 🔧 FIX: Await updatetable() để đảm bảo thứ tự thực thi
        await this.updatetable(this.defaultView);

        // Save state immediately after view is selected
        // Không cần setTimeout vì service là synchronous
        this.saveTableState();
    }

    async updatetable(view: ViewDto) {
        this.populateListeChamps(view);
        // 🔧 FIX: Await để đảm bảo populateListeChamps() hoàn thành trước khi load data
        await this.populateTableByfiltersAndSorts(view?.filter, this.sorts);
    }

    retrieveLabel(column: string): string {
        const champKey = this.retrieveChampKey(column);
        if (champKey !== null) {
            const labels = this.defaultView.labels;
            if (labels !== undefined && labels !== null && (<any>labels)[champKey]) {
                return (<any>labels)[champKey];
            }

            const findMatchLabel = this._dynamicDocumentInfo?.fields?.find(
                (item) => item?.name === column,
            )?.label as { [key: string]: any };

            if (findMatchLabel?.['fr_FR']) {
                return findMatchLabel['fr_FR'];
            }
        }

        return column;
    }

    retrieveChampKey(champ: string): number | null {
        if (
            this.defaultView === undefined ||
            this.defaultView.champs === undefined ||
            this.defaultView.champs === null
        ) {
            return null;
        }
        for (let i = 0; i < Object.keys(this.defaultView.champs).length; i++) {
            if ((<any>this.defaultView.champs)[i] === champ) {
                return i;
            }
        }
        return null;
    }

    editVisualisation(id: string) {
        this.tab.entite = this.entiteName;
        this.tab.listedechamps = this.listedechamps;
        this.tab.filterTypes = this.filterTypes;
        let editView = this.views.find((x) => x.id === id);
        if (editView !== undefined) {
            this.tab.view = editView;
        }

        this.tab.dialogName = 'visualisation';
        this.tab.listedechamps = this.listedechamps.filter((x) => x !== 'select');
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Modifier la visualisation',
                msg: ``,
                tab: {
                    ...this.tab,
                    allFields: this._dynamicDocumentInfo?.fields,
                },
            },
        });
    }

    visualiser() {
        if (this.userService.userHasRight('Lecture/Affichage dans le menu', this.tab.droitTitle)) {
            this.selection.selected.filter((value) => {
                this.ouvrirOnglet(value);
            });
            this.selection = new SelectionModel<any>(true, []);
            this.dash.saveTables();
        }
    }
    checkDynamic(entity: any) {
        if (entity.contains('dynamic')) {
            return true;
        }
        return false;
    }

    ouvrirOnglet(value: any) {
        // Save current state before navigating
        this.saveTableState();

        if (!this.userService.userHasRight('Lecture/Affichage dans le menu', this.tab.droitTitle)) {
            this.tab.msg = `Vous n'avez pas le droit de lecture sur ce fichier!`;
            this.tab.dialogName = 'popup';
            let dialogRef = this.dialog.open(DiaologHostComponent, {
                panelClass: 'filtre-dialog-component',
                data: {
                    title: 'Attention !',
                    msg: this.tab.msg,
                    tab: this.tab,
                },
            });
            return;
        }
        //TODO: add right check
        if (this.tab.isDynamic && this._dynamicDocumentInfo) {
            let tabField = this._dynamicDocumentInfo.tabField;

            this.dash.visualisation(
                this._dynamicDocumentService.getValue(value, tabField),
                this._dynamicDocumentInfo?.documentName,
                value.id,
                '',
                this.tab.totalElements,
                this._dynamicDocumentInfoService.getLabel(this._dynamicDocumentInfo),
            );
        }

        this.tab.totalElements = this.totalElements;
        const locales: string[] = this.getLocales();

        switch (this.tab.entite) {
            case 'dynamic_document_info':
                var titre = value.documentName
                    ? value.documentName
                    : value.name
                      ? value.name
                      : value.id;
                this.dash.visualisation(
                    titre,
                    this.tab.entite,
                    value.id,
                    '',
                    this.tab.totalElements,
                    this.tab.droitTitle,
                );
                break;

            case 'user':
                this.dash.visualisation(
                    value.lastname,
                    this.tab.entite,
                    value.id,
                    '',
                    this.tab.totalElements,
                    this.tab.droitTitle,
                );
                break;
            case 'role':
                this.dash.visualisation(
                    value.name,
                    this.tab.entite,
                    value.id,
                    '',
                    this.tab.totalElements,
                    this.tab.droitTitle,
                );
                break;
            case 'menu':
                this.dash.visualisation(
                    value.text,
                    this.tab.entite,
                    value.id,
                    '',
                    this.tab.totalElements,
                    this.tab.droitTitle,
                );
                break;
            case 'parametre':
                this.dash.visualisation(
                    value.valeur,
                    this.tab.entite,
                    value.id,
                    '',
                    this.tab.totalElements,
                    this.tab.droitTitle,
                );
                break;
        }
    }

    async ajouterUnEntite(entite: any, template: Template | null): Promise<void> {
        this.isOpenAddElement = false;

        if (this.tab?.entite.toLowerCase().includes('dynamic')) {
            this.tab.isDynamic = true;
        }
        const tab = new Tables();
        tab.type = this.type.get(this.tab.title);
        tab.title = 'Création ' + this.tab.title;
        tab.entite = entite;
        //tab.id = this.tab.id;
        tab.value = 'edition';
        tab.typeName = this.tab.typeName;

        let firstElement;
        if (!this.tab.isDynamic) {
            if (this.datasource.data[0] === undefined) {
                const data: any = await this.httpClient
                    .post<any[]>(`/view/filtres-and-sorts/${this.tab.entite}/0/1/fr_FR`, {
                        filters: [],
                        sorts: {},
                    })
                    .toPromise();

                firstElement = data.response[0];
            } else {
                firstElement = this.datasource.data[0];
            }
        }

        if (template === null) {
            const url: string = `template/${this.tab.entite.toLowerCase() + 'dto'}`;
            const templates: any = await this.httpClient.get(url).toPromise();
            if (templates !== null) {
                tab.template = this.findGoodTemplate(templates, firstElement);
            }
        } else {
            tab.template = template;
        }

        // Mark this as a fresh creation to prevent restoring old data
        // This ensures that when creating new article after closing previous one,
        // old data won't be restored
        (tab as any).isFreshCreation = true;
        this.dash.ajouterUnEntite(tab);
    }

    private findGoodTemplate(templates: any, firstElement: any) {
        for (const index in templates) {
            const template = templates[index];

            const layout = template.layout;
            if (
                layout === undefined ||
                layout === null ||
                layout.hasCondition === false ||
                layout.keyCondition === null
            ) {
                continue;
            }

            const v = firstElement[layout.keyCondition];
            if (v === undefined || v === null) {
                continue;
            }

            if (typeof v === 'boolean') {
                if (
                    v === true &&
                    (layout.valueCondition === true ||
                        layout.valueCondition === 'true' ||
                        layout.valueCondition === 1 ||
                        layout.valueCondition === '1')
                ) {
                    return template;
                } else if (
                    v === false &&
                    (layout.valueCondition === false ||
                        layout.valueCondition === 'false' ||
                        layout.valueCondition === 0 ||
                        layout.valueCondition === '0')
                ) {
                    return template;
                }
            }

            if (typeof v === 'object' && v.valeur !== undefined) {
                if (
                    v.valeur === layout.valueCondition ||
                    v.valeur.toString() == layout.valueCondition.toString()
                ) {
                    return template;
                }
            }

            if (v === layout.valueCondition || v.toString() == layout.valueCondition.toString()) {
                return template;
            }
        }

        return templates[0];
    }

    ouvrirPlusieursentites() {
        this.selection.selected.map((personne) => this.tables.push(personne));
        for (let i = 0; i < this.tables.length; i++) {}
    }

    processUserAction(useraction: MenuActions) {
        switch (useraction) {
            case MenuActions.REFRESH:
                this.rafraichir();
                break;
            case MenuActions.ADD:
                this.ajouterUnEntite(this.tab.entite, null);
                break;
            case MenuActions.VIEW:
                this.ouvrirPlusieursentites();
                break;
        }
    }

    refreshDataSource() {
        return this.datasource;
    }

    onSortChange(event: any) {
        let key: string = event.active;
        this.sorts = new Map();
        this.sorts.set(key, event.direction);
        // Save state after sort change
        this.saveTableState();
        this.rafraichir();
    }

    filtrer($event: Event, champ: string) {
        $event.preventDefault();
        $event.stopPropagation();
        this.tab.dialogName = 'filter-champ';
        this.tab.champ = champ;
        this.tab.locales = this.getLocales();

        // find type in docInfo
        let field = this._dynamicDocumentInfo?.fields.find((el) => el.name == champ);

        if (field) {
            switch (field.type) {
                case DynamicDocumentFieldInfoType.NUMBER:
                case DynamicDocumentFieldInfoType.BOOLEAN:
                case DynamicDocumentFieldInfoType.TEXT:
                    this.tab.champType = field.type;
                    break;
                case DynamicDocumentFieldInfoType.DATE_TIME:
                    this.tab.champType = 'DATE';
                    break;

                case DynamicDocumentFieldInfoType.PARAMETER_LINKS:
                    this.tab.champType = 'PARAMETER_LINKS';
                    break;

                case DynamicDocumentFieldInfoType.PARAMETER_LINK:
                case DynamicDocumentFieldInfoType.DOCUMENT_LINK:
                case DynamicDocumentFieldInfoType.DOCUMENT_LINKS:
                    this.tab.champType = 'LINK';
                    break;
                default:
                    this.tab.champType = 'UNKNOWN';
            }
        }

        if (this.tab.champType == 'UNKNOWN') {
            try {
                this.tab.champType = this.filterTypes[champ] ? this.filterTypes[champ] : 'UNKNOWN';
            } catch (e) {
                this.tab.champType = 'UNKNOWN';
            }
        } else if (this.tab.champType == undefined) {
            this.tab.champType = 'UNKNOWN';
        }

        // Ensure filters is in array format for consistent handling
        if (!this.filters) {
            this.filters = [];
        } else if (!Array.isArray(this.filters) && typeof this.filters === 'object') {
            // Convert object to array format
            const filtersArray: any[] = [];
            Object.keys(this.filters).forEach((key) => {
                if (this.filters[key]) {
                    if (this.filters[key].fieldName) {
                        filtersArray.push(this.filters[key]);
                    } else {
                        filtersArray.push({
                            fieldName: key,
                            ...this.filters[key],
                        });
                    }
                }
            });
            this.filters = filtersArray;
        }

        // Find existing filter for this field to show in dialog
        const existingFilter = Array.isArray(this.filters)
            ? this.filters.find((f: any) => f?.fieldName === champ)
            : null;
        this.tab.filter = existingFilter || null;

        //pour afficher le label de la colonne sur la pop-up
        const label = this.retrieveLabel(this.tab.champ);
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: `Recherche sur le champ : ${label.toUpperCase()}`,
                msg: ``,
                tab: {
                    ...this.tab,
                    nomTableField:
                        this._dynamicDocumentInfo?.fields?.find(
                            (item) => item.name === this.tab.champ,
                        )?.parameterLinkName ?? '',
                },
            },
        });
        dialogRef.afterClosed().subscribe((filter: any) => {
            if (filter !== undefined && filter !== null) {
                let tmpFilters = {
                    fieldName: filter.champ,
                    conditions: filter.conditions,
                };

                // Merge new filter with existing filters (preserve default filters)
                if (Array.isArray(this.filters)) {
                    // If filters is array, check if filter already exists and update it, otherwise add it
                    const existingIndex = this.filters.findIndex(
                        (f: any) => f?.fieldName === filter.champ,
                    );
                    if (existingIndex >= 0) {
                        // Update existing filter
                        this.filters[existingIndex] = tmpFilters;
                    } else {
                        // Add new filter (preserve existing filters)
                        this.filters.push(tmpFilters);
                    }
                } else if (this.filters && typeof this.filters === 'object') {
                    // If filters is object, merge new filter into object (preserve existing filters)
                    // Convert to array format for consistency
                    const filtersArray: any[] = [];
                    // Add existing filters from object
                    Object.keys(this.filters).forEach((key) => {
                        if (this.filters[key] && typeof this.filters[key] === 'object') {
                            // If filter has fieldName, use it, otherwise use key as fieldName
                            if (this.filters[key].fieldName) {
                                filtersArray.push(this.filters[key]);
                            } else {
                                filtersArray.push({
                                    fieldName: key,
                                    ...this.filters[key],
                                });
                            }
                        }
                    });
                    // Check if filter already exists and update it, otherwise add it
                    const existingIndex = filtersArray.findIndex(
                        (f: any) => f?.fieldName === filter.champ,
                    );
                    if (existingIndex >= 0) {
                        filtersArray[existingIndex] = tmpFilters;
                    } else {
                        filtersArray.push(tmpFilters);
                    }
                    this.filters = filtersArray;
                } else {
                    // If filters is null/undefined/empty, create new array with the filter
                    this.filters = [tmpFilters];
                }

                // Add type filter if needed (preserve it if already exists)
                if (
                    this.tab.entite !== 'personnemorale' &&
                    this.tab.typeName !== undefined &&
                    this.tab.typeName !== null
                ) {
                    // Convert filters to object format temporarily to add type filter
                    const filtersObj: any = Array.isArray(this.filters) ? {} : { ...this.filters };
                    if (Array.isArray(this.filters)) {
                        this.filters.forEach((f: any) => {
                            if (f && f.fieldName) {
                                filtersObj[f.fieldName] = f;
                            }
                        });
                    }
                    // Add or update type filter
                    filtersObj['type'] = {
                        champ: 'type',
                        conditions: [
                            {
                                id: 0,
                                type: 'TEXT',
                                condition: 'EQUALS',
                                valeur: this.tab.typeName,
                            },
                        ],
                        defaultValue: false,
                    };
                    // Convert back to array format
                    this.filters = Object.values(filtersObj).filter(
                        (f: any) => f !== null && f !== undefined,
                    );
                }

                this.pageIndex = 0;
                this.paginator.pageIndex = this.pageIndex;

                // Save state after filter change
                this.saveTableState();

                // 🔧 FIX: Đánh dấu filter vừa thay đổi để force gọi API
                this.isFilterChanged = true;
                this.populateTableByfiltersAndSorts(this.filters, this.sorts);
            } else if (filter === null) {
                // Remove filter for the specified field (preserve other filters)
                if (Array.isArray(this.filters)) {
                    this.filters = this.filters.filter((f: any) => f?.fieldName !== champ);
                } else if (this.filters && typeof this.filters === 'object') {
                    // Convert object to array, remove the filter, then convert back
                    const filtersArray: any[] = [];
                    Object.keys(this.filters).forEach((key) => {
                        if (key !== champ && this.filters[key]) {
                            if (this.filters[key].fieldName) {
                                filtersArray.push(this.filters[key]);
                            } else {
                                filtersArray.push({
                                    fieldName: key,
                                    ...this.filters[key],
                                });
                            }
                        }
                    });
                    this.filters = filtersArray.length > 0 ? filtersArray : [];
                } else {
                    delete this.filters[champ];
                }

                this.pageIndex = 0;
                this.paginator.pageIndex = this.pageIndex;

                // Save state after filter change
                this.saveTableState();

                // 🔧 FIX: Đánh dấu filter vừa thay đổi để force gọi API
                this.isFilterChanged = true;
                this.populateTableByfiltersAndSorts(this.filters, this.sorts);
            }
        });
    }

    async populateTableByfiltersAndSorts(filters: any, sorts: any) {
        try {
            const filresappliques = this.userService.roles
                .map((role) => role.backofficeRestrictions)
                .flatMap((backofficeRestriction) => backofficeRestriction.menu)
                .flatMap((menu) => menu.children)
                .filter((child) => child !== null)
                .filter((child) => child.text === this.tab.droitTitle)
                .map((child) => child.filresappliques)[0];

            // Only set from role restrictions if tab.filresappliques is not already set
            // This preserves filters restored from TableStateService
            if (
                !this.tab.filresappliques ||
                (Array.isArray(this.tab.filresappliques) &&
                    this.tab.filresappliques.length === 0) ||
                (typeof this.tab.filresappliques === 'object' &&
                    Object.keys(this.tab.filresappliques).length === 0)
            ) {
                this.tab.filresappliques = filresappliques;
            }
        } catch (e) {}

        // Only set filters from tab.filresappliques if filters parameter is empty/null
        // This preserves filters passed as parameter (from restored state)
        if (
            (filters && Array.isArray(filters) && filters.length > 0) ||
            (typeof filters === 'object' && Object.keys(filters).length > 0)
        ) {
            // Use filters from parameter (restored state or view filters)
            // Don't override with tab.filresappliques
        } else if (this.tab.filresappliques !== undefined && this.tab.filresappliques !== null) {
            this.filters = this.tab.filresappliques;
        } else if (filters && Object.keys(filters).length === 0) {
            this.filters = [];
        }

        // Keep this.filters in array format for consistency
        // Only convert to object format temporarily when calling parseFilters
        if (filters === undefined || filters === null) {
            filters = [];
        }

        // Ensure this.filters is always in array format
        if (Array.isArray(filters)) {
            this.filters = filters;
        } else if (filters && typeof filters === 'object') {
            // Convert object to array format
            const filtersArray: any[] = [];
            Object.keys(filters).forEach((key) => {
                if (filters[key]) {
                    if (filters[key].fieldName) {
                        filtersArray.push(filters[key]);
                    } else {
                        filtersArray.push({
                            fieldName: key,
                            ...filters[key],
                        });
                    }
                }
            });
            this.filters = filtersArray;
        } else {
            this.filters = [];
        }

        if (this.filters === undefined || this.filters === null) {
            this.filters = [];
        }

        // Ensure columnDefs is set before parsing filters (to avoid this.columnDefs?.some error)
        if (!this.columnDefs && this._dynamicDocumentInfo?.fields) {
            this.columnDefs = this._dynamicDocumentInfo.fields;
        }
        const locales: string[] = this.getLocales();
        let page = this.pageIndex == 0 ? 1 : this.pageIndex;

        // Track if data was loaded from dynamic document APIs
        let dataLoaded = false;

        if (this.tab.isDynamic && this._dynamicDocumentInfo?.documentName) {
            const locales: string[] = this.getLocales();
            try {
                const data = await firstValueFrom(
                    this._dynamicDocumentService.find({
                        viewId: this.defaultView.id,
                        collectionName: this._dynamicDocumentInfo?.documentName,
                        filters: this.parseFilters(this.convertFiltersToObject(this.filters)),
                        sorts: Object.fromEntries(this.sorts),
                        page: page,
                        pageSize: this.pageSize,
                        locales: locales /* Close Fix Visualisation */,
                        timezone: this.clientTimeZone,
                        isHandlingSpecialFields: false,
                    }),
                );

                // CHỈ DÙNG SEARCH API - Đảm bảo columnDefs được set
                this.datasource.data = data.content;
                this.totalElements = data.totalElements;
                dataLoaded = true;

                // 🔧 FIX: Kiểm tra xem có state cần restore không
                // Nếu có state cần restore, không gọi populateListeChamps() ở đây
                // vì restoreTableState() sẽ gọi sau đó với view đúng
                const tabId = this.getCurrentTabId();
                const state = this.tableStateService.getState(tabId, this.tab.entite);
                // 🔧 FIX: Check cả restoredViewId để biết view đã được restore chưa
                // Nếu view đã được restore (restoredViewId === state.selectedViewId), không cần restore lại
                const hasStateToRestore =
                    state &&
                    state.selectedViewId &&
                    (!this.defaultView || this.defaultView.id !== state.selectedViewId) &&
                    this.restoredViewId !== state.selectedViewId; // View chưa được restore

                if (!hasStateToRestore) {
                    // Chỉ gọi populateListeChamps() nếu:
                    // 1. Không có state cần restore, HOẶC
                    // 2. View đã được restore (restoredViewId === state.selectedViewId)
                    // Đảm bảo dùng đúng view đã được set trong selectView()
                    if (this.defaultView && this.defaultView.id) {
                        // 🔧 FIX: CHỈ gọi populateListeChamps() nếu listedechamps chưa được set đúng
                        // Tránh overwrite view đã được restore
                        const needsPopulate =
                            !this.listedechamps ||
                            this.listedechamps.length <= 1 ||
                            this.restoredViewId !== this.defaultView.id;
                        if (needsPopulate) {
                            this.populateListeChamps(this.defaultView);
                        }
                    } else {
                        // Fallback: tìm selectedView từ this.views nếu defaultView chưa được set
                        let selectedView = this.views.find((el) => el.isselected);
                        if (selectedView) {
                            this.populateListeChamps(selectedView);
                        } else if (!this.columnDefs && this._dynamicDocumentInfo?.fields) {
                            // Fallback: set columnDefs từ _dynamicDocumentInfo nếu chưa có
                            this.columnDefs = this._dynamicDocumentInfo.fields;
                        }
                    }
                } else if (!this.columnDefs && this._dynamicDocumentInfo?.fields) {
                    // Nếu có state cần restore, chỉ set columnDefs nếu chưa có
                    this.columnDefs = this._dynamicDocumentInfo.fields;
                }

                // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                // Data đã có trong datasource.data, không cần setTimeout
                this.restoreTableState();
            } catch (error) {
                console.error('Error loading dynamic document data:', error);
            }
        } else {
            if (this._dynamicDocumentInfo?.documentName) {
                try {
                    const data = await firstValueFrom(
                        this._dynamicDocumentService.find({
                            collectionName: this._dynamicDocumentInfo?.documentName,
                            filters: this.parseFilters(this.convertFiltersToObject(this.filters)),
                            sorts: Object.fromEntries(this.sorts),
                            page: page,
                            pageSize: this.pageSize,
                            locales: locales,
                            timezone: this.clientTimeZone,
                        }),
                    );

                    this.datasource.data = data.content;
                    this.totalElements = data.totalElements;
                    dataLoaded = true;

                    // 🔧 FIX: Kiểm tra xem có state cần restore không
                    // Nếu có state cần restore, không gọi populateListeChamps() ở đây
                    // vì restoreTableState() sẽ gọi sau đó với view đúng
                    const tabId = this.getCurrentTabId();
                    const state = this.tableStateService.getState(tabId, this.tab.entite);
                    // 🔧 FIX: Check cả restoredViewId để biết view đã được restore chưa
                    // Nếu view đã được restore (restoredViewId === state.selectedViewId), không cần restore lại
                    const hasStateToRestore =
                        state &&
                        state.selectedViewId &&
                        (!this.defaultView || this.defaultView.id !== state.selectedViewId) &&
                        this.restoredViewId !== state.selectedViewId; // View chưa được restore

                    if (!hasStateToRestore) {
                        // Chỉ gọi populateListeChamps() nếu:
                        // 1. Không có state cần restore, HOẶC
                        // 2. View đã được restore (restoredViewId === state.selectedViewId)
                        // 🔧 FIX: CHỈ gọi populateListeChamps() nếu listedechamps chưa được set đúng
                        // Tránh overwrite view đã được restore
                        if (this.defaultView && this.defaultView.id) {
                            const needsPopulate =
                                !this.listedechamps ||
                                this.listedechamps.length <= 1 ||
                                this.restoredViewId !== this.defaultView.id;
                            if (needsPopulate) {
                                this.populateListeChamps(this.defaultView);
                            }
                        } else {
                            // Fallback: tìm selectedView từ this.views nếu defaultView chưa được set
                            let selectedView = this.views.find((el) => el.isselected);
                            if (selectedView) this.populateListeChamps(selectedView);
                        }
                    } else if (!this.columnDefs && this._dynamicDocumentInfo?.fields) {
                        // Nếu có state cần restore, chỉ set columnDefs nếu chưa có
                        this.columnDefs = this._dynamicDocumentInfo.fields;
                    }

                    // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                    // Data đã có trong datasource.data, không cần setTimeout
                    this.restoreTableState();
                } catch (error) {
                    console.error('Error loading dynamic document data:', error);
                }
            }
        }

        // Chỉ gọi API filtres-and-sorts nếu:
        // 1. Chưa có data được load từ các API phía trên (không phải dynamic document)
        // 2. Chưa có data trong datasource.data HOẶC filter vừa thay đổi (isFilterChanged = true)
        // 3. Không phải dynamic document
        const hasData =
            this.datasource?.data &&
            Array.isArray(this.datasource.data) &&
            this.datasource.data.length > 0;
        const isNonDynamicEntity = !this.tab.isDynamic && !this._dynamicDocumentInfo?.documentName;

        // 🔧 FIX: Force gọi API nếu filter vừa thay đổi (kể cả khi đã có data)
        // Điều này đảm bảo data được refresh với filter mới
        const shouldCallApi =
            !dataLoaded && isNonDynamicEntity && (!hasData || this.isFilterChanged);

        if (shouldCallApi) {
            try {
                const data = await firstValueFrom(
                    this.httpClient.post<{
                        response: any[];
                        totalItems: number;
                        columndefs: any[];
                    }>(
                        `/view/filtres-and-sorts/${this.tab.entite}/${this.pageIndex}/${this.pageSize}/${locales}`,
                        {
                            filters: this.parseFiltersByChamp(Object.values(this.filters)),
                            sorts: sorts,
                        },
                    ),
                );

                if (this.tab?.droitTitle != 'Produits') {
                    this.datasource.data = data.response;
                    this.totalElements = data.totalItems;
                    this.columnDefs = data.columndefs;
                    this.myTableService.setDataSource(this.tab.entite, this.datasource);

                    this.sort?.sortChange.subscribe(() => {
                        this.loadSortedData(this.sort.active, this.sort.direction);
                    });
                    this.datasource.sort = this.sort;

                    // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                    // Data đã có trong datasource.data, không cần setTimeout
                    this.restoreTableState();
                }

                // 🔧 FIX: Reset flag sau khi đã gọi API thành công
                this.isFilterChanged = false;
            } catch (error) {
                console.error('Error loading filters and sorts data:', error);
                // 🔧 FIX: Reset flag ngay cả khi có lỗi để tránh stuck state
                this.isFilterChanged = false;
            }
        } else {
            // 🔧 FIX: Reset flag nếu không gọi API (trường hợp dynamic document đã load data)
            this.isFilterChanged = false;
        }

        // REMOVED: API filtres-and-sorts không còn cần thiết
        // Chỉ dùng search API (_dynamicDocumentService.find()) vì:
        // 1. Search API đã có đầy đủ filters, sorts, pagination
        // 2. Search API có data đầy đủ (có value trong DOCUMENT_LINKS)
        // 3. columnDefs đã có từ _dynamicDocumentInfo?.fields hoặc populateListeChamps()
        // 4. Tránh duplicate API calls và data overwrite issues
    }
    //}
    //   }

    parseFiltersByChamp(filters: any[]) {
        return filters.map((filter) => {
            if (filter.fieldName)
                return {
                    champ: filter.fieldName,
                    conditions: filter.conditions.map((cond: any) => {
                        return { ...cond, valeur: cond.value };
                    }),
                };
            else return filter;
        });
    }

    /**
     * Convert filters array to object format for parseFilters
     * This is a temporary conversion - this.filters should always remain in array format
     */
    private convertFiltersToObject(filters: any): { [key: string]: any } {
        if (!filters) {
            return {};
        }
        if (Array.isArray(filters)) {
            const filtersObj: any = {};
            filters.forEach((filter) => {
                if (filter && filter.fieldName) {
                    filtersObj[filter.fieldName] = filter;
                }
            });
            return filtersObj;
        }
        if (typeof filters === 'object') {
            return filters;
        }
        return {};
    }

    parseFilters(filters: typeof this.filters): any {
        let res: any[] = [];
        if (filters) {
            let _filters = Array.from(Object.entries(filters));

            if (_filters) {
                _filters.forEach((filter) => {
                    let mergedConditions: any[] = [];
                    filter[1]?.conditions.map((cond: any) => {
                        let condIndex = mergedConditions.findIndex(
                            (tmp: any) => tmp?.type === cond.condition || tmp?.type === cond.type,
                        );
                        if (
                            condIndex !== -1 &&
                            cond.type !== DynamicDocumentFieldInfoType.PARAMETER_LINKS
                        ) {
                            mergedConditions[condIndex] = {
                                id: filter[1]?.conditions.length,
                                type: 'IN',
                                value: [
                                    mergedConditions.find(
                                        (tmp: any) => tmp?.type === cond.condition,
                                    )?.value,
                                    cond.value,
                                ],
                                minValue: cond.valeurMin,
                                maxValue: cond.valeurMax,
                                fieldType: cond.type,
                            };
                        } else {
                            mergedConditions.push({
                                id: filter[1]?.conditions.length,
                                type: cond.condition || cond.type,
                                value: cond?.valeur?.value ? cond?.valeur?.value : cond?.value,
                                minValue: cond.valeurMin,
                                maxValue: cond.valeurMax,
                                fieldType: cond.type,
                            });
                        }
                    });

                    if (mergedConditions) {
                        // Ensure columnDefs is an array before calling .some()
                        const isMultiLang =
                            Array.isArray(this.columnDefs) &&
                            this.columnDefs.some(
                                (field: any) => field.name === filter[0] && field.isMultilingual,
                            );
                        if (isMultiLang) {
                            this.languages.map((lang) => {
                                if (lang.selected && lang.key !== 'all') {
                                    const fieldName =
                                        filter[0] === 'hit'
                                            ? filter[0]
                                            : filter[0] + '.' + lang.key;
                                    res.push({
                                        fieldName: fieldName,
                                        conditions: mergedConditions,
                                    });
                                }
                            });
                        } else {
                            const fieldName = filter[0] === 'hit' ? filter[0] : filter[0];
                            res.push({ fieldName: fieldName, conditions: mergedConditions });
                        }
                    }
                });
            }
        }

        return res;
    }

    parseFiltersParameterLinks(filters: typeof this.filters) {}

    private retrieveChildren(parent: any): any[] | null {
        if (parent.children) {
            const subChildren: any[] = [];

            for (const child of parent.children) {
                if (typeof child === 'string') {
                    continue;
                }

                const subChild: any = {
                    id: child.id,
                    name: child,
                    subChildren: this.retrieveChildren(child),
                };

                subChildren.push(subChild);
            }

            return subChildren;
        }

        return [];
    }

    public retrieveTreeName(element: any): string {
        let name = '';

        if (element.code !== undefined && element.code !== null) {
            name = element.code;
        }

        if (
            element.maplocaletitre !== undefined &&
            element.maplocaletitre !== null &&
            Object.keys(element.maplocaletitre).length > 0
        ) {
            const titre = element.maplocaletitre[this.getLocales()[0]];
            if (titre !== undefined && titre !== null && titre !== '') {
                if (name !== '') {
                    name += ' - ';
                }
                name += titre;
            }
        }

        if (name === '') {
            name = element.id;
        }

        return name;
    }

    filtreActive(champ: string): boolean {
        if (this.filters === undefined || this.filters === null) {
            return false;
        }

        // Handle array format (current format)
        if (Array.isArray(this.filters)) {
            return this.filters.some(
                (f: any) => f?.fieldName === champ && f !== null && f !== undefined,
            );
        }

        // Handle object format (legacy format)
        if (typeof this.filters === 'object') {
            return this.filters[champ] !== undefined && this.filters[champ] !== null;
        }

        return false;
    }

    viderfiltres() {
        // Handle array format (current format)
        if (Array.isArray(this.filters)) {
            // Keep only filters with defaultValue = true
            this.filters = this.filters.filter((f: any) => f?.defaultValue === true);
        }
        // Handle object format (legacy format)
        else if (this.filters && typeof this.filters === 'object') {
            Object.keys(this.filters).forEach((key) => {
                if (!this.filters[key]?.defaultValue) {
                    delete this.filters[key];
                }
            });
        }

        this.tab.filresappliques = this.filters;

        this.datasource.data = this.initData;

        this.pageIndex = 0;
        this.pageSize = 25;
        this.paginator.pageIndex = this.pageIndex;
        this.paginator.pageSize = this.pageSize;

        // 🔧 FIX: Gọi selectView với isManual=false vì đây là reset pagination (automatic)
        this.selectView(this.defaultView, false);
    }

    hasFiltres() {
        if (this.filters === undefined || this.filters === null) {
            return false;
        }

        // Handle array format (current format)
        if (Array.isArray(this.filters)) {
            return this.filters.some((f) => {
                return f !== null && (f.defaultValue === undefined || !f.defaultValue);
            });
        }

        // Handle object format (legacy format)
        if (typeof this.filters === 'object') {
            return (
                Object.keys(
                    Object.values(this.filters).filter((f) => {
                        return f !== null || (f.defaultValue !== undefined && !f.defaultValue);
                    }),
                ).length > 0
            );
        }

        return false;
    }

    isDefaultFilter(column: string): boolean {
        if (this.filters === undefined || this.filters === null) {
            return false;
        }

        let filter: any = null;

        // Handle array format (current format)
        if (Array.isArray(this.filters)) {
            filter = this.filters.find((f: any) => f?.fieldName === column);
        }
        // Handle object format (legacy format)
        else if (typeof this.filters === 'object') {
            filter = this.filters[column];
        }

        if (filter !== undefined && filter !== null) {
            return filter?.defaultValue !== undefined && filter?.defaultValue;
        }

        return false;
    }

    getSelectedLanguageKey(): string | null {
        const selectedLanguage = this.languages.find((l) => l.selected);
        return selectedLanguage ? selectedLanguage.key : null;
    }

    onChangeLanguageByKey(key: string) {
        this.languages.forEach((l) => (l.selected = false));
        const language = this.languages.find((l) => l.key === key);
        if (language !== undefined) {
            language.selected = true;
            this.onChangeLanguage(language);
        }
    }

    onChangeLanguage(language: Language) {
        if (language.key === 'all') {
            this.languages.forEach((l) => (l.selected = language.selected));
        } else if (language.selected === false) {
            const allLanguages = this.languages.find((l) => l.key == 'all');
            if (allLanguages !== undefined) {
                allLanguages.selected = false;
            }
        } else if (language.selected === true) {
            if (
                this.languages.length -
                    this.languages.filter((language) => language.selected).length ===
                1
            ) {
                const allLanguages = this.languages.find((l) => l.key == 'all');
                if (allLanguages !== undefined) {
                    allLanguages.selected = true;
                }
            }
        }
        this.updateLanguagesFilter();
    }

    private updateLanguagesFilter() {}

    isVisible(locale: string): boolean {
        return this.languages.find((l) => l.key === locale && l.selected) !== undefined;
    }

    initFiltres() {
        this.filterTypes = this.viewService.filterConditions();
        this.tab.filterTypes = this.filterTypes;
    }

    loadDynamicDocuments() {
        if (this._dynamicDocumentInfo) {
            // 🔧 FIX: Sử dụng pageIndex thay vì hardcode page: 1
            // pageIndex là 1-based, nhưng API cần 0-based, nên convert
            const page = this.pageIndex > 0 ? this.pageIndex : 1;

            if (
                this.defaultView !== null &&
                this.defaultView.id !== null &&
                this.defaultView.id !== '1' &&
                this.defaultView.nom !== 'Default'
            ) {
                this._dynamicDocumentService
                    .find({
                        viewId: this.defaultView.id,
                        collectionName: this._dynamicDocumentInfo.documentName,
                        filters: this.parseFilters(this.convertFiltersToObject(this.filters)),
                        sorts: Object.fromEntries(this.sorts),
                        page: page,
                        pageSize: this.pageSize,
                        timezone: this.clientTimeZone,
                    })
                    .subscribe((data: any) => {
                        this.datasource.data = data.content;
                        this.totalElements = data.totalElements;
                        // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                        // Data đã có trong datasource.data, không cần setTimeout
                        this.restoreTableState();
                    });
            } else {
                this._dynamicDocumentService
                    .find({
                        collectionName: this._dynamicDocumentInfo.documentName,
                        filters: this.parseFilters(this.convertFiltersToObject(this.filters)),
                        sorts: Object.fromEntries(this.sorts),
                        page: page,
                        pageSize: this.pageSize,
                        timezone: this.clientTimeZone,
                    })
                    .subscribe((data: any) => {
                        this.datasource.data = data.content;
                        this.totalElements = data.totalElements;
                        // 🔧 FIX: Gọi restoreTableState trực tiếp sau khi data đã được set
                        // Data đã có trong datasource.data, không cần setTimeout
                        this.restoreTableState();
                    });
            }
        }
    }

    nextPage(event: PageEvent) {
        this.selection.clear();
        this.pageIndex = event.pageIndex + 1;
        this.pageSize = event.pageSize;

        if (this.defaultView !== undefined && this.defaultView !== null) {
            this.defaultView.isselected = true;
            this.defaultView.filter = this.filters ? this.filters : [];

            // 🔧 FIX: Gọi selectView với isManual=false vì đây là pagination change (automatic)
            this.selectView(this.defaultView, false);
        }

        // 🔧 FIX: Save state sau khi pageIndex được update để đảm bảo paginator state được lưu
        // Điều này quan trọng để restore đúng trang khi quay lại từ detail page
        this.saveTableState();
    }

    hasImages(element: any): boolean {
        return Object.keys(element.images).length > 0;
    }

    pictoNameToLabel(pictoName: string): string {
        return PictosUtils.toLabel(pictoName);
    }

    private getLocales(): string[] {
        return this.languages
            .filter((language: Language) => language.key !== 'all' && language.selected)
            .map((language: Language) => language.key);
    }

    @ViewChild('addElementRef') addElementRef: ElementRef;

    @ViewChild('languagesElementRef') languagesElementRef: ElementRef;

    @HostListener('document:click', ['$event'])
    onCloseLanguages(event: any) {
        if (this.isOpenAddElement && !this.addElementRef.nativeElement.contains(event.target)) {
            this.isOpenAddElement = false;
        }

        if (
            this.isOpenLanguages &&
            !this.languagesElementRef.nativeElement.contains(event.target)
        ) {
            this.isOpenLanguages = false;
            this.updateLanguagesFilter();
        }
    }

    onOpenLanguages(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpenLanguages = !this.isOpenLanguages;
    }

    onOpenAddElement(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpenAddElement = !this.isOpenAddElement;
    }

    onSwitchOn() {
        if (this.switchOn === 'tree') {
            this.switchOn = 'table';
        } else {
            this.switchOn = 'tree';
        }
        this.populateTableByfiltersAndSorts(this.filters, this.sorts);
    }

    onExportIdml() {
        this._idmlService.exportFile().subscribe((data: Blob) => {
            const link: HTMLAnchorElement = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = 'export.idml';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
        });
    }

    private retrieveDynamicDocumentInfo(documentName: string): Promise<DynamicDocumentInfo | null> {
        return new Promise<DynamicDocumentInfo | null>(
            (resolve: (dynamicDocumentInfo: DynamicDocumentInfo | null) => void) => {
                this._dynamicDocumentInfoService.findByDocumentName(documentName).subscribe({
                    next: (dynamicDocumentInfo: DynamicDocumentInfo) => {
                        // Is dynamic document
                        resolve(dynamicDocumentInfo);
                    },
                    error: () => {
                        // Is static document
                        resolve(null);
                    },
                });
            },
        );
    }

    listenLanguageChange() {
        this.translate.stream('Admin.Tooltip.create').subscribe((res: string) => {
            this.tooltipTranslate.create = res;
        });
        this.translate.stream('Admin.Tooltip.refresh').subscribe((res: string) => {
            this.tooltipTranslate.refresh = res;
        });
        this.translate.stream('Admin.Tooltip.visualisation').subscribe((res: string) => {
            this.tooltipTranslate.visualisation = res;
        });
        this.translate.stream('Admin.Tooltip.language').subscribe((res: string) => {
            this.tooltipTranslate.language = res;
        });
        this.translate.stream('Admin.Tooltip.import').subscribe((res: string) => {
            this.tooltipTranslate.import = res;
        });
        this.translate.stream('Admin.Tooltip.export').subscribe((res: string) => {
            this.tooltipTranslate.export = res;
        });
        this.translate.stream('Admin.Tooltip.delete').subscribe((res: string) => {
            this.tooltipTranslate.delete = res;
        });
    }

    /**
     * Toggle selection for an item and save state
     */
    toggleSelection(item: any): void {
        this.selection.toggle(item);
        this.saveTableState();
    }

    /**
     * Get current tab ID from URL
     * Example: http://localhost:4200/admin/viewid-101 -> returns "viewid-101"
     */
    private getCurrentTabId(): string | null {
        try {
            const url = window.location.href;
            const arr = url.split('/');
            const viewId = arr[arr.length - 1];
            return viewId || null;
        } catch (error) {
            console.error('Error getting tab ID from URL:', error);
            return null;
        }
    }

    /**
     * Save all table state (selection, sort, filters) to TableStateService
     * Uses In-Memory Store + sessionStorage for persistence
     */
    private saveTableState(): void {
        if (!this.tab || !this.tab.entite) {
            return;
        }

        const tabId = this.getCurrentTabId();
        if (!tabId) {
            return;
        }

        try {
            // Save selection IDs
            const selectedIds = this.selection.selected
                .map((item) => item.id)
                .filter((id) => id != null);

            // Save sort state
            let sortState: { active: string; direction: 'asc' | 'desc' | '' } | undefined =
                undefined;
            if (this.sorts && this.sorts.size > 0) {
                const firstSort = Array.from(this.sorts.entries())[0];
                if (firstSort) {
                    sortState = {
                        active: firstSort[0],
                        direction: firstSort[1] as 'asc' | 'desc' | '',
                    };
                }
            }

            // Save filters
            let filtersToSave: any[] | undefined = undefined;
            if (
                this.filters &&
                ((Array.isArray(this.filters) && this.filters.length > 0) ||
                    (typeof this.filters === 'object' && Object.keys(this.filters).length > 0))
            ) {
                filtersToSave = Array.isArray(this.filters)
                    ? this.filters
                    : Object.values(this.filters).filter((f) => f !== null && f !== undefined);
            }

            // Save selected view ID
            let selectedViewId: string | null | undefined = undefined;
            if (this.defaultView && this.defaultView.id) {
                selectedViewId = this.defaultView.id;
            } else if (this.views && this.views.length > 0) {
                const selectedView = this.views.find((v) => v.isselected);
                if (selectedView && selectedView.id) {
                    selectedViewId = selectedView.id;
                }
            }

            // Save paginator state
            // Note: pageIndex in component is 1-based (pageIndex = event.pageIndex + 1)
            // But MatPaginator uses 0-based index, so we save the 0-based index for MatPaginator
            const paginatorPageIndex = this.pageIndex > 0 ? this.pageIndex - 1 : 0;

            const state: {
                selection?: any[];
                sort?: { active: string; direction: 'asc' | 'desc' | '' };
                filters?: any[];
                selectedViewId?: string | null;
                pageIndex?: number;
                pageSize?: number;
            } = {
                selection: selectedIds.length > 0 ? selectedIds : undefined,
                sort: sortState,
                filters: filtersToSave,
                selectedViewId: selectedViewId,
                pageIndex: paginatorPageIndex,
                pageSize: this.pageSize,
            };

            // Save to In-Memory Service (synchronous, no race conditions)
            // Service will also persist to sessionStorage automatically
            this.tableStateService.saveState(tabId, this.tab.entite, state);
        } catch (error) {
            console.error('Error saving table state:', error);
        }
    }

    /**
     * Restore all table state (selection, sort, filters) from TableStateService
     * Only called AFTER data is loaded to avoid interfering with API calls
     */
    private restoreTableState(): void {
        if (
            !this.tab ||
            !this.tab.entite ||
            !this.datasource ||
            !this.datasource.data ||
            this.datasource.data.length === 0
        ) {
            return;
        }

        const tabId = this.getCurrentTabId();
        let state = this.tableStateService.getState(tabId, this.tab.entite);

        // 🔧 FIX: Fallback to find state from another tab with same entity if no state found for current tab
        // NGUYÊN NHÂN: Khi user back từ detail page, hệ thống tạo tab mới với tabId mới (ví dụ: viewid-104)
        // Nhưng state được lưu với tabId cũ (ví dụ: viewid-103) khi user chọn view
        // Vì vậy, khi back về visualisation table, tabId khác với tabId khi user chọn view, nên không tìm thấy state
        // Giải pháp: Fallback để tìm state của tab khác cùng entity
        if (!state) {
            state = this.tableStateService.getStateForEntity(this.tab.entite, tabId);
        }

        if (!state) {
            return;
        }

        // 🔧 FIX: Kiểm tra xem đã restore view này chưa để tránh gọi nhiều lần
        // CHỈ return nếu đang restore (isRestoringState = true) VÀ view đã được restore (restoredViewId === selectedViewId)
        // VÀ listedechamps đã có đầy đủ (length > 1)
        // KHÔNG return nếu chỉ có currentViewId === savedViewId vì có thể cần restore selection, sort, filters
        if (
            state.selectedViewId === this.restoredViewId &&
            this.isRestoringState &&
            this.listedechamps &&
            this.listedechamps.length > 1
        ) {
            return; // Đang restore view này rồi và listedechamps đã có đầy đủ, không cần restore lại
        }

        // 🔧 FIX: Cancel timeout cũ từ populateListeChamps() để tránh race condition
        if (this.populateListeChampsTimeout) {
            clearTimeout(this.populateListeChampsTimeout);
            this.populateListeChampsTimeout = null;
        }

        // Set flag để tránh gọi lại
        this.isRestoringState = true;

        try {
            // Restore selection
            if (state.selection && Array.isArray(state.selection) && state.selection.length > 0) {
                const selection = state.selection; // Store in local variable to avoid null check issues
                const itemsToSelect = this.datasource.data.filter((item: any) => {
                    if (!item || !item.id) return false;
                    const itemId = String(item.id);
                    return selection.some((savedId: any) => String(savedId) === itemId);
                });

                if (itemsToSelect.length > 0) {
                    this.selection.clear();
                    this.selection.select(...itemsToSelect);
                }
            }

            // Restore selectedViewId - CHỈ restore nếu view chưa được set manually
            // Điều này tránh conflict khi chuyển visualisation
            // 🔧 FIX: Không restore view nếu đã được chọn manually
            // 🔧 FIX: CHỈ restore view khi view đã được restore trong setView() (restoredViewId đã được set)
            // Điều này đảm bảo chỉ restore view khi tab đã có state được lưu trước đó (ví dụ: back từ detail của cùng tab)
            // Với tab mới, không restore view từ state, chỉ dùng default view
            const shouldRestoreView =
                !this.isViewManuallySelected &&
                !!state.selectedViewId &&
                !!this.views &&
                this.views.length > 0 &&
                (!this.defaultView || this.defaultView.id !== state.selectedViewId) &&
                !!this.restoredViewId && // CHỈ restore khi view đã được restore trong setView()
                this.restoredViewId === state.selectedViewId; // CHỈ restore khi view đã được restore trong setView() và match với saved view
            if (shouldRestoreView && state.selectedViewId) {
                const selectedViewId = state.selectedViewId; // Store in local variable to avoid null check issues
                const viewToRestore = this.views.find((v) => v.id === selectedViewId);
                if (viewToRestore) {
                    this.views.forEach((v) => (v.isselected = false));
                    viewToRestore.isselected = true;
                    this.defaultView = viewToRestore;
                    this.defaultVisualisation = viewToRestore.nom || '';

                    // 🔧 FIX: Gọi populateListeChamps() để đảm bảo listedechamps được update đúng
                    // Điều này quan trọng khi restore state sau khi back từ item
                    this.populateListeChamps(viewToRestore);

                    // Lưu viewId đã restore để tránh restore lại
                    this.restoredViewId = state.selectedViewId || null;
                    // Reset flag sau khi restore thành công
                    this.isViewManuallySelected = false;
                }
            }

            // Restore sort state
            // 🔧 FIX: Không dùng setTimeout, dùng cdr.detectChanges() và Promise.resolve()
            // để đảm bảo MatSort component đã được init
            if (state.sort && state.sort.active && state.sort.direction) {
                this.sorts = new Map();
                this.sorts.set(state.sort.active, state.sort.direction);

                // Force change detection để đảm bảo sort component đã được init
                this.cdr.detectChanges();

                // Kiểm tra sort đã được init chưa
                if (this.sort) {
                    // Sort component đã sẵn sàng, set trực tiếp
                    this.sort.active = state.sort.active;
                    this.sort.direction = state.sort.direction as 'asc' | 'desc' | '';
                    if (this.datasource) {
                        this.datasource.sort = this.sort;
                    }
                    // Force change detection để apply sort
                    this.cdr.detectChanges();
                } else {
                    // Nếu sort chưa init, đợi đến next change detection cycle
                    // Sử dụng Promise.resolve() thay vì setTimeout (an toàn hơn)
                    Promise.resolve().then(() => {
                        if (
                            this.sort &&
                            state?.sort &&
                            state?.sort?.active &&
                            state?.sort?.direction
                        ) {
                            const sortState = state?.sort; // Store in local variable to avoid null check issues
                            this.sort.active = sortState?.active;
                            this.sort.direction = sortState?.direction as 'asc' | 'desc' | '';
                            if (this.datasource) {
                                this.datasource.sort = this.sort;
                            }
                            this.cdr.detectChanges();
                        }
                    });
                }
            }

            // Restore paginator state
            // 🔧 FIX: CHỈ sync paginator UI với giá trị hiện tại (đã được restore bởi restoreStateBeforeLoad())
            // KHÔNG restore lại this.pageIndex và this.pageSize vì chúng đã được restore trước đó
            // Khi user chọn view manually, paginator đã được reset về trang 1, không nên restore lại
            if (
                state.pageIndex !== undefined &&
                state.pageSize !== undefined &&
                !this.isViewManuallySelected
            ) {
                // 🔧 FIX: KHÔNG restore lại this.pageIndex và this.pageSize vì chúng đã được restore bởi restoreStateBeforeLoad()
                // Chỉ sync paginator UI với giá trị hiện tại
                // Note: this.pageIndex is 1-based, MatPaginator.pageIndex is 0-based
                const paginatorPageIndex = this.pageIndex > 0 ? this.pageIndex - 1 : 0;

                // 🔧 FIX: Cancel subscription cũ nếu có để tránh race condition khi có nhiều API calls đồng thời
                if (this.paginatorSyncSubscription) {
                    this.paginatorSyncSubscription.unsubscribe();
                    this.paginatorSyncSubscription = null;
                    this.isSyncingPaginator = false;
                }

                // 🔧 FIX: Kiểm tra xem đã đang sync paginator chưa để tránh multiple syncs đồng thời
                if (this.isSyncingPaginator) {
                    return;
                }

                // 🔧 FIX: Validate data đã sẵn sàng trước khi sync paginator
                if (
                    !this.paginator ||
                    !this.totalElements ||
                    this.totalElements <= 0 ||
                    !this.datasource?.data ||
                    this.datasource.data.length === 0
                ) {
                    return;
                }

                // 🔧 FIX: Đánh dấu đang sync để tránh multiple syncs đồng thời
                this.isSyncingPaginator = true;

                // 🔧 FIX: Sync paginator SAU KHI totalElements đã được set để tránh MatPaginator tự động reset
                // MatPaginator có thể tự động reset pageIndex khi [length] thay đổi
                // Cần đợi Angular update view với totalElements mới trước khi sync paginator
                // Sử dụng RxJS observeOn(asyncScheduler) - Angular-native way để schedule async operations
                // asyncScheduler sử dụng setInterval/setTimeout internally nhưng được quản lý bởi RxJS
                // Đây là cách được recommend bởi Angular/RxJS để schedule async operations
                this.paginatorSyncSubscription = of(null)
                    .pipe(observeOn(asyncScheduler))
                    .subscribe({
                        next: () => {
                            try {
                                // 🔧 FIX: Validate lại data trước khi sync (có thể đã thay đổi do API call mới)
                                if (
                                    !this.paginator ||
                                    !this.totalElements ||
                                    this.totalElements <= 0 ||
                                    !this.datasource?.data ||
                                    this.datasource.data.length === 0
                                ) {
                                    this.isSyncingPaginator = false;
                                    return;
                                }

                                // Validate pageIndex không vượt quá số trang tối đa
                                const maxPageIndex = Math.max(
                                    0,
                                    Math.ceil(this.totalElements / this.pageSize) - 1,
                                );
                                const validPageIndex = Math.min(paginatorPageIndex, maxPageIndex);

                                // 🔧 FIX: Set paginator properties
                                this.paginator.pageIndex = validPageIndex;
                                this.paginator.pageSize = this.pageSize;

                                // 🔧 FIX: Mark component for check để đảm bảo binding [pageIndex] được update
                                this.cdr.markForCheck();

                                // Force change detection to apply paginator changes
                                this.cdr.detectChanges();

                                // 🔧 FIX: Double-check sau một microtask để đảm bảo paginator không bị reset bởi MatPaginator
                                // queueMicrotask chạy sau khi Angular đã hoàn thành change detection cycle hiện tại
                                // Không phải setTimeout, đây là cách Angular-native để schedule microtask
                                queueMicrotask(() => {
                                    if (this.paginator && this.totalElements > 0) {
                                        const expectedPageIndex = this.paginatorPageIndex;
                                        const actualPageIndex = this.paginator.pageIndex;

                                        if (actualPageIndex !== expectedPageIndex) {
                                            // MatPaginator đã reset pageIndex, cần set lại
                                            this.paginator.pageIndex = expectedPageIndex;
                                            this.cdr.markForCheck();
                                            this.cdr.detectChanges();
                                        } else {
                                        }
                                    }
                                });
                            } catch (error: any) {
                            } finally {
                                // 🔧 FIX: Reset flag sau khi sync hoàn tất (hoặc lỗi)
                                this.isSyncingPaginator = false;
                                this.paginatorSyncSubscription = null;
                            }
                        },
                        error: (err) => {
                            this.isSyncingPaginator = false;
                            this.paginatorSyncSubscription = null;
                        },
                        complete: () => {
                            // Subscription completed
                        },
                    });
            } else if (this.isViewManuallySelected) {
            }

            // 🔧 FIX: Reset flag sau khi restore xong
            this.isRestoringState = false;
        } catch (error) {
            console.error('Error restoring table state:', error);
            // Reset flag nếu có lỗi
            this.isRestoringState = false;
        }
    }

    /**
     * Restore state (sort, filters) BEFORE loading data
     * This ensures data is loaded with correct sort and filters
     */
    private restoreStateBeforeLoad(tabState?: any): void {
        if (!this.tab || !this.tab.entite) {
            return;
        }

        const tabId = this.getCurrentTabId();
        let state = tabState; // Use provided state if available

        // If no state provided, try to find it
        if (!state) {
            state = this.tableStateService.getState(tabId, this.tab.entite);

            // 🔧 FIX: Fallback to find state from another tab with same entity if no state found for current tab
            if (!state) {
                const fallbackState = this.tableStateService.getStateForEntity(
                    this.tab.entite,
                    tabId,
                );

                // 🔧 FIX: Nếu tìm thấy state từ fallback, copy sang tabId hiện tại để lần sau tìm thấy đúng
                if (fallbackState && tabId && tabId.startsWith('viewid-')) {
                    // Copy state sang tabId hiện tại
                    this.tableStateService.saveState(tabId, this.tab.entite, fallbackState);
                }

                state = fallbackState;
            }
        }

        if (!state) {
            return;
        }

        try {
            // Restore sort state Map (needed before loading data)
            // This MUST be restored to ensure data is loaded with correct sort
            if (state.sort && state.sort.active) {
                this.sorts = new Map();
                // direction can be empty string, so check if it exists (not null/undefined)
                if (state.sort.direction !== null && state.sort.direction !== undefined) {
                    this.sorts.set(state.sort.active, state.sort.direction);
                } else {
                    // If direction is empty, set to empty string
                    this.sorts.set(state.sort.active, '');
                }
            }

            // Restore filters - prioritize saved filters from state
            // Always restore filters from state if available (highest priority)
            // 🔧 FIX: Chỉ restore filters nếu chưa có filters được restore từ setView()
            // Tránh overwrite filters đã được restore trong setView()
            const hasExistingFilters =
                this.filters &&
                ((Array.isArray(this.filters) && this.filters.length > 0) ||
                    (typeof this.filters === 'object' && Object.keys(this.filters).length > 0));

            if (!hasExistingFilters) {
                if (state.filters && Array.isArray(state.filters) && state.filters.length > 0) {
                    // Keep filters as array format to match onFilterChange expectations
                    this.filters = state.filters;
                    this.tab.filresappliques = state.filters;
                } else if (
                    state.filters &&
                    typeof state.filters === 'object' &&
                    Object.keys(state.filters).length > 0
                ) {
                    // Convert object filters to array format
                    this.filters = Object.values(state.filters).filter(
                        (f: any) => f !== null && f !== undefined,
                    );
                    this.tab.filresappliques = this.filters;
                } else {
                    // No filters in state, clear filters
                    this.filters = [];
                    this.tab.filresappliques = [];
                }
            }

            // Restore paginator state BEFORE loading data
            // This ensures API calls use the correct pageIndex/pageSize
            if (state.pageIndex !== undefined && state.pageSize !== undefined) {
                // Update component pageIndex and pageSize
                // Note: state.pageIndex is 0-based (for MatPaginator)
                // But component.pageIndex is 1-based, so we convert
                this.pageIndex = state.pageIndex + 1;
                this.pageSize = state.pageSize;
            }
        } catch (error) {
            console.error('Error restoring state before load:', error);
        }
    }
}
